<template>
  <div>
    <model-table
      add-label="Roles"
      submodel
      :collection="user.roles"
      :columns="[
        { field: 'name' },
        { field: 'permissionCount' },
        { field: 'userCount' },
        { field: 'autoAssignAdmin', component: 'checkbox' },
        { field: 'autoAssignEmployee', component: 'checkbox' },
        { name: 'actions', align: 'right' }
      ]"
      :show-edit="false"
      :show-add="$isPermitted($permissions.Security.View)"
      @add="$refs.userRolesSelectDialog.show()"
    >
      <role-form />
    </model-table>
    <select-user-roles-dialog
      ref="userRolesSelectDialog"
      :user="user"
    />
  </div>
</template>

<script>
import User from 'src/models/user/User'
import ModelTable from 'src/modules/admin/components/ModelTable'
import RoleForm from 'src/modules/admin/role/RoleForm'
import SelectUserRolesDialog from 'src/modules/admin/user/SelectUserRolesDialog'

export default {
  name: 'UserRolesTable',
  components: {
    ModelTable,
    SelectUserRolesDialog,
    RoleForm
  },
  props: {
    user: {
      type: User,
      required: true
    }
  }
}
</script>
